import { createFileRoute } from '@tanstack/react-router';

import { SiteDirectionsPage } from '@/features/owner/site/SiteDirectionsPage';

export const Route = createFileRoute('/_authed/owner/site/directions')({
  component: SiteDirectionsPage,
});
